/**
 * Constantes de errores centralizadas para AgroError
 * Cada error define:
 * - title: Título del error
 * - subtitle: Subtítulo con mensaje explicativo
 * - image: Nombre de la imagen en /assets/img/
 * - hasAction: Si tiene acción de reintento
 * - action: Nombre de la action a ejecutar
 * - actionPayload: Payload dinámico (se completa al disparar el error)
 * - buttonLabel: Etiqueta del botón (opcional)
 * - returnRoute: Ruta a donde volver
 * - successAction: Action a ejecutar si el reintento es exitoso
 * - tituloMaxIntentos: Título alternativo al alcanzar máximo de intentos
 * - subtituloMaxIntentos: Subtítulo alternativo al alcanzar máximo de intentos
 */

import * as ACTIONS from "@/config/constants/action-types";

export const genericTitle = "No pudimos validar tu información";
export const genericSubtitle =
  "En este momento no podemos procesar la solicitud. <br> Intentá nuevamente más tarde";
export const genericImage = "1x/error.svg";
export const genericButtonLabelAceptar = "Aceptar";
export const genericButtonLabelVolver = "Volver";

export const AGRO_ERROR_TYPES = {
  ES_CLIENTE_ERROR: {
    title: genericTitle,
    subtitle: "Intentá de nuevo",
    image: genericImage,
    hasAction: true,
    action: ACTIONS.DO_CALL_API_ES_CLIENTE,
    tituloMaxIntentos: genericTitle,
    subtituloMaxIntentos: genericSubtitle,
    returnRoute: "/agropaso1",
    buttonLabel: "Reintentar"
  },
  OTP_USER_BLOCKED: {
    title: "Alcanzaste el límite de intentos",
    subtitle:
      "Por seguridad, pausamos la validación.<br/>Vas a poder intentar de nuevo en 24 horas.",
    image: genericImage,
    hasAction: false
  },
  GENERIC_ERROR: {
    title: genericTitle,
    subtitle: genericSubtitle,
    image: genericImage,
    hasAction: false,
    buttonLabel: genericButtonLabelVolver
  }
};

/**
 * Helper para crear un objeto de error con payload personalizado
 * @param {string} errorType - Clave del tipo de error (de AGRO_ERROR_TYPES)
 * @param {object} customPayload - Payload personalizado (opcional)
 * @returns {object} Objeto de error completo
 */
export const createAgroError = (errorType, customPayload = {}) => {
  const baseError =
    AGRO_ERROR_TYPES[errorType] || AGRO_ERROR_TYPES.GENERIC_ERROR;

  return {
    ...baseError,
    ...customPayload
  };
};

/**
 * Obtener error por tipo
 * @param {string} errorType - Clave del tipo de error
 * @returns {object} Objeto de error
 */
export const getAgroError = errorType => {
  return AGRO_ERROR_TYPES[errorType] || AGRO_ERROR_TYPES.GENERIC_ERROR;
};
